import { render, staticRenderFns } from "./diagnostic_centers.vue?vue&type=template&id=8de810bc&scoped=true"
import script from "./diagnostic_centers.vue?vue&type=script&lang=js"
export * from "./diagnostic_centers.vue?vue&type=script&lang=js"
import style0 from "./diagnostic_centers.vue?vue&type=style&index=0&id=8de810bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de810bc",
  null
  
)

export default component.exports